import styled from 'styled-components';

export const Container = styled.div`
  padding: 10px 16px 16px 16px;
  width: 100%;
  height: fit-content;
  background-color: #ffffff;
  position: fixed;
  bottom: 0;
  left: 0;

  z-index: 1000;
  overflow-x: hidden;
  transition: 0.3s ease-in-out 0.5s;
  transition: height 0.1s ease-out;

  transition-delay: 0s;
  box-shadow: 0px -5px 10px 0px #57575733;
`;

interface DrawerContentProps {
  $open: boolean;
  $contentHeight: number;
}

export const DrawerContent = styled.div<DrawerContentProps>`
  overflow-x: hidden;
  overflow-y: auto;
  max-height: 70dvh;
  transition: height 0.5s ease-out;
  height: ${({ $open }) => ($open ? `fit-content` : '0')};
  /* height: ${({ $open, $contentHeight }) => ($open ? `${$contentHeight}px` : '0')}; */
`;

export const ToggleControl = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin-bottom: 8px;
  cursor: pointer;
`;

export const Title = styled.div`
  color: #333333;
  font-size: 16px;
  font-weight: 700;
  line-height: 19px;
  letter-spacing: 0em;
  text-align: left;
  margin-bottom: 16px;
`;

export const Total = styled.div`
  display: flex;
  justify-content: space-between;

  color: #4d4d4d;
  font-size: 19px;
  font-weight: 700;
  line-height: 23px;
  letter-spacing: 0em;
  text-align: right;
`;
